import { EuiButtonEmpty, EuiContextMenu, EuiIcon, EuiPopover } from "@elastic/eui";
import React, { useContext, useState } from "react";

import { ShopContext } from "../utils/Shop";
import { Shop } from "../utils/types";
import { removeTableSettingsFromLocalStorage } from "../utils/Utils";

export const ShopSwitcher = () => {
    const [isPopoverOpen, setPopover] = useState(false);
    const { setShopName, setShopId, shopGroups, shopName, setIsUsingMultiScreen } = useContext(ShopContext);
    const userAllowedShops = shopGroups.map((shopGroup) => shopGroup.shops).flat();

    const ShopSwitcherList: {
        icon: JSX.Element;
        name: string;
        href: string;
        onClick: () => void;
    }[] = [];
    if (shopGroups) {
        userAllowedShops?.map((item: Shop) =>
            ShopSwitcherList?.push({
                icon: <EuiIcon type="eye" size="m" />,
                name: item.name,
                onClick: () => {
                    setShopName(item.name);
                    setShopId(item.id);
                    setIsUsingMultiScreen(item.is_using_multiscreen);
                    removeTableSettingsFromLocalStorage();
                    window.location.reload();
                },
                href: "#",
            })
        );
    }

    const onButtonClick = () => {
        setPopover(!isPopoverOpen);
    };

    const closePopover = () => {
        setPopover(false);
    };

    const button = (
        <EuiButtonEmpty iconType="arrowDown" iconSide="right" onClick={onButtonClick}>
            {shopName}
        </EuiButtonEmpty>
    );

    const panels = [
        {
            id: 0,
            title: shopName,
            items: ShopSwitcherList,
        },
    ];

    return (
        <EuiPopover
            id="contextMenuExample"
            button={button}
            isOpen={isPopoverOpen}
            closePopover={closePopover}
            panelPaddingSize="none"
            anchorPosition="downLeft"
        >
            <EuiContextMenu initialPanelId={0} panels={panels} />
        </EuiPopover>
    );
};
